import React from 'react';
import { post } from '../../communication/httpClient';

export default class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (Object.keys(error).length > 0) {
      const errorData = {
        logType: 'error',
        logMessage: {
          error,
          errorInfo,
        },
      };
      post('/api/logger', errorData);
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
    }
    return this.props.children;
  }
}
